import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { fetchProfile, editUser } from "../../slices/thunks";
import { resetProfileFlag } from "../../slices/auth/profile/reducer";
import NameInput from "../../common/NameInput";
import EmailInput from "../../common/EmailInput";
import PasswordInput from "../../common/PasswordInput";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const UserProfile = () => {
  const dispatch = useDispatch();
  const { user, success, error, loading } = useSelector((state) => state.Profile);
  const [formValues, setFormValues] = useState(null);

  useEffect(() => {
    dispatch(fetchProfile());

    return () => {
      dispatch(resetProfileFlag());
    };
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      console.log("User data received:", user);
      setFormValues({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        password: "",
      });
    }
  }, [user]);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: formValues || {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
    },
    onSubmit: async (values) => {
      const payload = {
        id: user?._id,
        data: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          password: values.password ? values.password : user.password,
        },
      };

      await dispatch(editUser(payload));
      dispatch(fetchProfile());
    },

  });


  if (!formValues) return <Alert color="info">Loading profile...</Alert>;

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Edit Profile' pageTitle='Profile' />
        </Container>
      </div>
      <div className="table-container" style={{ marginTop: "15px" }}>
        <Card>
          <CardBody>
            <Form onSubmit={validation.handleSubmit}>
              <NameInput
                name="firstName"
                id="firstName"
                label="First Name"
                showHelp={true}
                helpText="Please enter your firstName name."
                required={true}
                value={validation?.values?.firstName}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                error={validation?.touched?.firstName && validation?.errors?.firstName}
              />

              <NameInput
                name="lastName"
                id="lastName"
                label="Last Name"
                required={true}
                value={validation?.values?.lastName}
                onChange={validation.handleChange}
                showHelp={true}
                helpText="Please enter your lastName name."
                onBlur={validation?.handleBlur}
                error={validation?.touched?.lastName && validation?.errors?.lastName}
              />

              <EmailInput
                name="email"
                id="email"
                required={true}
                layout="below"
                showHelp={false}
                disabled={true}
                value={validation?.values?.email}
              />

              <PasswordInput
                name="password"
                id="password"
                required={false}
                layout="below"
                placeholder="Enter your password"
                showHelp={true}
                helpText="Please enter a strong password."
                value={validation?.values?.password}
                onChange={validation?.handleChange}
                onBlur={validation?.handleBlur}
                error={validation?.touched?.password && validation?.errors?.password}
              />

              <div className="text-center mt-4">
                <Button type="submit" style={{ backgroundColor: "#00209F" }}>
                  Update Profile
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
